export enum PriceRuleEntity {
  company = 0,
  plant = 1,
  pricelist = 2,
  baseprice = 3,
  customer = 4,
  project = 5
}